<script lang="ts">
  import type { EventObject } from "../interfaces/event";
  import { createObjectMap } from "../services/shared";
  import { eventConfig } from "../../public/configuration";
  import PropertyValue from "./property-value.svelte";

  let _eventObject: EventObject | null = null;
  export let eventObject: EventObject | null = null;
  $: {
    if (eventObject && _eventObject?.key !== eventObject.key) {
      const objectMap = eventObjectMaps.find(eom => eom.name === eventObject.key)?.objectMap ?? {};
      if (typeof objectMap === 'object' && !Object.keys(objectMap).length) {
        createObjectMap('', [], eventObject, objectMap);
        createdObjectMap(eventObject.key, objectMap);
      }
      _eventObject = eventObject;
    }
  }

  export let eventObjectMaps: any[] = [];
  export let createdObjectMap = (eventName: string, objectMap: any) => null;

  let configuration = eventConfig;
</script>

<div class="event">
  <div class="event__body">
    <PropertyValue
      {configuration}
      objectMap={eventObjectMaps.find(eom => eom.name === eventObject.key)?.objectMap ?? {}}
      value={eventObject}
    />
  </div>
</div>
